import { ForgotPasswordModelI,
  GetRefreshTokenI,
  HelpInfoI,
  LoginModelI,
  RefreshTokenModelI,
  UserSessionI,
  authTypes,
  getAuthTypes } from "./authTypes";

export const login = (payload: LoginModelI): getAuthTypes => ({
  type: authTypes.LOGIN,
  payload,
});

export const loginSuccess = (payload: UserSessionI): getAuthTypes => ({
  type: authTypes.LOGIN_SUCCESS,
  payload,
});

export const loginFailure = (payload: string): getAuthTypes => ({
  type: authTypes.LOGIN_FAILURE,
  payload,
});

export const logout = (): getAuthTypes => ({
  type: authTypes.LOGOUT,
});

export const didTryAutoLogin = (): getAuthTypes => ({
  type: authTypes.DID_TRY_AUTO_LOGIN,
});

export const forgotPassword = (payload: ForgotPasswordModelI, onSuccess?: () => void): getAuthTypes => ({
  type: authTypes.FORGOT_PASSWORD,
  payload,
  onSuccess,
});

export const forgotPasswordSuccess = (): getAuthTypes => ({
  type: authTypes.FORGOT_PASSWORD_SUCCESS,
});

export const forgotPasswordFailure = (payload: string): getAuthTypes => ({
  type: authTypes.FORGOT_PASSWORD_FAILURE,
  payload,
});

export const getHelpInfo = (): getAuthTypes => ({
  type: authTypes.GET_HELP_INFO,
});

export const getHelpInfoSuccess = (payload: HelpInfoI): getAuthTypes => ({
  type: authTypes.GET_HELP_INFO_SUCCESS,
  payload,
});

export const getHelpInfoFailure = (payload: string): getAuthTypes => ({
  type: authTypes.GET_HELP_INFO_FAILURE,
  payload,
});

export const getRefreshToken = (payload: any, actionToDispatch: any): GetRefreshTokenI => ({
  type: authTypes.GET_REFRESH_TOKEN,
  payload,
  actionToDispatch,
});

export const getRefreshTokenSuccess = (payload: any): getAuthTypes => ({
  type: authTypes.GET_REFRESH_TOKEN_SUCCESS,
  payload,
});

export const getRefreshTokenFailure = (payload: RefreshTokenModelI): getAuthTypes => ({
  type: authTypes.GET_REFRESH_TOKEN_FAILURE,
  payload,
});

export const getUsers = (): getAuthTypes => ({
  type: authTypes.GET_USERS,
});

export const getUsersSuccess = (payload: any): getAuthTypes => ({
  type: authTypes.GET_USERS_SUCCESS,
  payload,
});

export const getUsersFailure = (payload: string): getAuthTypes => ({
  type: authTypes.GET_USERS_FAILURE,
  payload,
});
